export default __webpack_public_path__ + "static/media/Chhatt_agri_f.f5528ccc.wav";